import { Invoice } from 'contracts/tracking-v2/invoices';

export const isNumericValue = (value: any) => {
  if (value === null || value === undefined) return false;
  return !isNaN(value);
};

export const getInvoiceSupplierCoordinates = (supplier: Invoice['supplier']): google.maps.LatLngLiteral | string => {
  const { addressLatitude, addressLongitude } = supplier;

  if (isNumericValue(addressLatitude) && isNumericValue(addressLongitude)) {
    return {
      lat: Number(addressLatitude),
      lng: Number(addressLongitude),
    };
  }

  const {
    addressStreet, addressNumber, addressNeighborhood, addressCity, addressState,
  } = supplier;

  return [
    addressStreet,
    ...(addressNumber === 'SN' ? [] : [addressNumber]),
    addressNeighborhood,
    addressCity,
    addressState,
  ].filter(Boolean).join(', ');
};

export const getInvoiceCompanyCoordinates = (company: Invoice['company']): google.maps.LatLngLiteral | string => {
  const { addressLatitude, addressLongitude } = company;

  if (isNumericValue(addressLatitude) && isNumericValue(addressLongitude)) {
    return {
      lat: Number(addressLatitude),
      lng: Number(addressLongitude),
    };
  }

  const {
    addressStreet, addressNumber, addressNeighborhood, addressCity, addressState,
  } = company;

  return [
    addressStreet,
    ...(addressNumber === 'SN' ? [] : [addressNumber]),
    addressNeighborhood,
    addressCity,
    addressState,
  ].filter(Boolean).join(', ');
};